module.exports = __webpack_public_path__ + "media/images/pc/visit_reserve/kv-title-left-197db133c6e48e92609056bcf8b1b912.png";